var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.4355C11.3807 11.4355 12.5 10.3163 12.5 8.93555C12.5 7.55483 11.3807 6.43555 10 6.43555C8.61929 6.43555 7.5 7.55483 7.5 8.93555C7.5 10.3163 8.61929 11.4355 10 11.4355Z",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 8.93555C16.25 14.5605 10 18.9355 10 18.9355C10 18.9355 3.75 14.5605 3.75 8.93555C3.75 7.27794 4.40848 5.68823 5.58058 4.51613C6.75269 3.34403 8.3424 2.68555 10 2.68555C11.6576 2.68555 13.2473 3.34403 14.4194 4.51613C15.5915 5.68823 16.25 7.27794 16.25 8.93555Z",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.fb86954737f2a1fe6f2fa1e4feacd78a.svg";
export { ForwardRef as ReactComponent };